module.exports = __webpack_public_path__ + "img/icon_back.021f8e2a.svg";